export const configData = {
  BASE_URL: process.env.REACT_APP_API_URL,
};

export function getApiUrl(path) {
  return `${configData.BASE_URL.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
}
